export enum BrmActionType {
  RestrictionProhibitAction = 'RestrictionProhibitAction',
  ProhibitAction = 'ProhibitAction',
  ConfirmationAction = 'ConfirmationAction',
  RestrictionReasonCodeAction = 'RestrictionReasonCodeAction',
  ReasonCodeAction = 'ReasonCodeAction',
  RestrictionApprovalAction = 'RestrictionApprovalAction',
  ApprovalAction = 'ApprovalAction',
  InputDataAction = 'InputDataAction',
  AgeRestrictionAction = 'AgeRestrictionAction',
  LoyaltyAction = 'CustomerAction',
  TenderAmountExceededInformationAction = 'TenderAmountExceededInformationAction',
  NotificationAction = 'NotificationAction',
  OnlineItemAuthorization = 'OnlineItemAuthorization',
  PriceEntryRequired = 'PriceEntryRequired',
  ItemNotFound = 'ItemNotFound',
}
